import React, { useState } from "react";
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import SwitchToggle from "../../components/SwitchToggle";

const ManageDispatcher = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const handleCloseModal = () => setOpenModal(false);

  // Sample dispatcher data
  const dispatchers = [
    {
      id: "DISP001",
      name: "Rahul Sharma",
      email: "rahul.sharma@example.com",
      phone: "+91 9876543210",
      address: "New Delhi, India",
    },
    {
      id: "DISP002",
      name: "Alicia Brown",
      email: "alicia.brown@example.com",
      phone: "+1 555-340-2211",
      address: "San Francisco, USA",
    },
  ];

  return (
    <>
      <div className="main_title">
        <h1>Manage Dispatchers</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Dispatchers
        </p>
      </div>

      <div className="cards">
        {/* Header with Search and Add Button */}
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Dispatchers"
            />
          </div>

          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("add")}
            >
              <AddIcon /> Add Dispatcher
            </Button>
          </div>
        </div>

        {/* Table */}
        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Dispatcher Details</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>Enable / Disable</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {dispatchers.map((dispatcher) => (
                <TableRow hover key={dispatcher.id}>
                  {/* ID */}
                  <TableCell>{dispatcher.id}</TableCell>

                  {/* Dispatcher Details */}
                  <TableCell>
                    <div className="user_block">
                      <figure>
                        <img
                          src="/static/images/user_placeholder.png"
                          alt="Dispatcher"
                        />
                      </figure>
                      <p>
                        <b>{dispatcher.name}</b>
                        <span>{dispatcher.phone}</span>
                        <span>{dispatcher.email}</span>
                      </p>
                    </div>
                  </TableCell>

                  {/* Address */}
                  <TableCell>{dispatcher.address}</TableCell>

                  {/* Toggle */}
                  <TableCell>
                    <SwitchToggle />
                  </TableCell>

                  {/* Actions */}
                  <TableCell>
                    <div className="table_actions v2">
                      
                        <a href="manage-dispatcher" className="btn btn_primary sm">View Panel</a>
                      <IconButton
                        onClick={() =>
                          navigate("add", { state: { dispatcher } })
                        }
                      >
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="Edit"
                        />
                      </IconButton>

                      <IconButton>
                        <img
                          src="/static/images/trash2_icon.svg"
                          alt="Delete"
                        />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

    </>
  );
};

export default ManageDispatcher;
